import { Link } from "react-router-dom";
import react, { useEffect, useRef, useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import axios from "axios";
import { JwtDecoder } from "../../Utils/JwtDecoder";
import { toast } from "react-toastify";
import base_url from "../../Utils/server";

export const UserPosts = ({
  posts,
  setPosts,
  matchArray,
  setMatchArray,
  url,
}) => {
  const Token = sessionStorage.getItem("jwtToken");
  const [noMatch, setNoMatch] = useState(null);
  //   let userid=
  function findMatches(wordToMatch, posts) {
    return posts.filter((post) => {
      let regex;
      try {
        regex = new RegExp(wordToMatch, "gi");
      } catch (e) {
        if (post.description != null) {
          return post.description;
        }
      }
      if (post.description != null) {
        return post.description.match(regex);
      }
    });
  }
  function handleSearch(e) {
    // console.log(e);
    const matchArray = findMatches(e.target.value, posts);
    // console.log(matchArray);
    if (e.target.value.length > 0) {
      if (matchArray.length == 0) {
        setNoMatch("no");
      } else {
        setMatchArray(matchArray);
        setNoMatch(null);
      }
    } else {
      setNoMatch(null);
      setMatchArray(posts);
    }
  }
  useEffect(() => {
    axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if (res.data.status == "success") {
          setPosts(res.data.data);
          setMatchArray(res.data.data);
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        toast.error("Error fetching posts");
      });
  }, []);

  function deletepost(e, pid) {
    axios
      .delete(`${base_url}/posts/${pid}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if (res.data.status == "success") {
          toast.success("Post Deleted", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
          axios
            .get(`${url}`, {
              headers: {
                Authorization: `Bearer ${Token}`,
              },
            })
            .then((res) => {
              setPosts(res.data.data);
              setMatchArray(res.data.data);
            })
            .catch((e) => {
              toast.error("Error deleting posts");
            });
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((err) => {
        toast.error("Error deleting posts");
      });
  }
  function deleteComment(e, cid) {
    axios
      .delete(`${base_url}/comment/${cid}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if (res.data.status == "success") {
          toast.success("Comment Deleted", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
          axios
            .get(`${url}`, {
              headers: {
                Authorization: `Bearer ${Token}`,
              },
            })
            .then((res) => {
              setPosts(res.data.data);
              setMatchArray(res.data.data);
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        toast.error("Error deleting comment");
      });
  }
  function addComment(e, comm) {
    const data = { commentText: e.target[0].value };
    if (e.target[0].value.length > 0) {
      axios
        .post(`${base_url}/post/${comm}/comment`, data, {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        })
        .then((res) => {
          if (res.data.status == "success") {
            let newar = posts.map((item) => {
              if (item.postId == comm) {
                return { ...item, comments: res.data.data };
              } else {
                return item;
              }
            });
            setPosts(newar);
            setMatchArray(newar);
            e.target[0].value = "";
          } else {
            toast.error(res.data.message)
          }
        })
        .catch((w) => {
          toast.error("Error adding comment");
        });
    }
  }
  function handleLike(e, isliked, id) {
    if (isliked) {
      axios
        .delete(`${base_url}/unlike/${id}`, {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        })
        .then((res) => {
          if (res.data.status == "success") {
            axios
              .get(`${url}`, {
                headers: {
                  Authorization: `Bearer ${Token}`,
                },
              })
              .then((res) => {
                setPosts(res.data.data);
                setMatchArray(res.data.data);
              })
              .catch((e) => {
                toast.error("Network Error");
              });
          } else {
            toast.error(res.data.message)
          }
        })
        .catch((e) => {
          toast.error("Error unliking the post");
        });
    } else {
      axios
        .post(
          `${base_url}/like/${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.status == "success") {
            axios
              .get(`${url}`, {
                headers: {
                  Authorization: `Bearer ${Token}`,
                },
              })
              .then((res) => {
                setPosts(res.data.data);
                setMatchArray(res.data.data);
              })
              .catch((e) => {
                toast.error("Network Error");
              });
          } else {
            toast.error(res.data.message)
          }
        })
        .catch((e) => {
          toast.error("Error liking the post");
        });
    }
  }

  return (
    <section className="relative ">
      <section className="absolute overflow-y-scroll h-screen noscrollbar left-80 py-6 w-4/5 min-h-screen .overflow-auto .overscroll-auto">
        {matchArray.length > 0 && (
          <h3 className="m-4 text-gray-800 text-3xl font-semibold sm:text-4xl">
            Manage Posts -
          </h3>
        )}
        <div className="max-w-screen-xl mx-auto px-4 md:px-8 ">
          <div className="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="absolute top-0 bottom-0 w-6 h-6 my-auto text-gray-400 left-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              onChange={(e) => {
                handleSearch(e);
              }}
              type="text"
              placeholder="Search Posts"
              className="w-full py-3 pl-12 pr-4 text-gray-500 border rounded-md outline-none bg-gray-50 focus:bg-white focus:border-indigo-600"
            />
          </div>

          <div className="mt-12 flex justify-center ">
            <ul className="grid gap-8 sm:grid-cols-1 w-4/5  md:grid-cols-2">
              {matchArray.length != 0 && noMatch && (
                <span className="block text-gray-700 text-sm font-semibold">
                  No match found
                </span>
              )}
              {matchArray.length == 0 && (
                <span className="block text-gray-700 text-sm font-semibold">
                  You have no posts. Please Add a New Post.
                </span>
              )}
              {noMatch == null &&
                matchArray.length > 0 &&
                matchArray.map((item, idx) => (
                  <li key={idx} className="border-2 p-4 shadow-md rounded-md">
                    <div className="py-4 px-4">
                      <div className="flex items-center gap-x-4">
                        <img
                          src={item.profileImage}
                          className="w-12 h-12 rounded-full"
                        />
                        <div>
                          <span className="block text-gray-700 text-sm font-semibold">
                            {item.userFullName}
                          </span>
                          <p className="block mt-px text-gray-600 text-xs">
                            @{item.userName}
                          </p>
                          <span className="block mt-px text-gray-600 text-xs">
                            {item.creationTime}
                          </span>
                        </div>
                        <div className="flex items-center justify-center ml-auto">
                          <div
                            className="cursor-pointer"
                            onClick={(e) => deletepost(e, item.postId)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <polyline points="3 6 5 6 21 6"></polyline>
                              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                              <line x1="10" y1="11" x2="10" y2="17"></line>
                              <line x1="14" y1="11" x2="14" y2="17"></line>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    {item.postImage && (
                      <div className="w-full h-60 sm:h-52 md:h-56">
                        <img
                          src={item.postImage}
                          className="w-full h-full object-cover object-center shadow-md rounded-xl"
                          alt=""
                        />
                      </div>
                    )}
                    <div className="mt-4">
                      <p className="text-gray-600 mt-2">{item.description}</p>
                      <div className="mt-3 flex items-center gap-4 text-gray-700">
                        <button>
                          <FaHeart
                            onClick={(e) => {
                              handleLike(e, item.isliked, item.postId);
                            }}
                            style={{
                              color: item.isliked == 1 ? "red" : "#ddd",
                              fontSize: "28px",
                            }}
                          />
                        </button>
                        <span className=" -mt-1 block text-gray-700 text-lg font-semibold">
                          {item.likes}
                        </span>
                      </div>
                    </div>

                    {item.comments.length > 0 && (
                      <>
                        <span className="block text-gray-700 text-sm font-semibold mt-3">
                          Comments
                        </span>
                        <ol className="h-36 overflow-y-scroll ">
                          {item.comments.map((ite, id) => {
                            return (
                              <li key={id}>
                                <div className="py-4 px-4 border mt-1">
                                  <div className="flex items-between gap-x-4">
                                    <img
                                      src={ite.profileImage}
                                      className="w-6 h-6 rounded-full"
                                    />
                                    <div className="flex-col items-start gap-x-4">
                                      <div className="flex gap-x-4 justify-between">
                                        <span className="block text-gray-700 text-sm font-semibold">
                                          {ite.userFullName}
                                        </span>
                                        <p className="block mt-px text-gray-600  text-xs">
                                          {ite.creationTime}
                                        </p>
                                      </div>
                                      <p className="block mt-px text-gray-600  text-xs">
                                        {ite.commentText}
                                      </p>
                                    </div>

                                    <div
                                      className="ml-auto cursor-pointer"
                                      onClick={(e) =>
                                        deleteComment(e, ite.commentId)
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                        <line
                                          x1="10"
                                          y1="11"
                                          x2="10"
                                          y2="17"
                                        ></line>
                                        <line
                                          x1="14"
                                          y1="11"
                                          x2="14"
                                          y2="17"
                                        ></line>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ol>
                      </>
                    )}
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        addComment(e, item.postId);
                      }}
                      className="mt-5 bottom-0 items-center justify-center sm:flex"
                    >
                      <textarea
                        rows={1}
                        placeholder="Comment"
                        className="text-gray-500 w-full p-3 rounded-md border outline-none focus:border-indigo-600"
                      ></textarea>
                      <button className="w-full mt-3 px-5 py-3 rounded-md text-white hover:bg-gray-200 active:bg-black-700 duration-150 outline-none shadow-md focus:shadow-none  sm:mt-0 sm:ml-3 sm:w-auto">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                        >
                          <path d="M16,464,496,256,16,48V208l320,48L16,304Z" />
                        </svg>
                      </button>
                    </form>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </section>
    </section>
  );
};
